import axios from 'axios'
import { Rate } from './types'

export const RATES_ENDPOINT = 'https://rates.dailyforex.com/rates'
export const noop = (): void => {}

export const api = {
  async getRates(): Promise<Rate[]> {
    try {
      const response = await axios.get<Rate[]>(RATES_ENDPOINT)
      return response.data
    } catch (error: unknown) {
      if (axios.isCancel(error)) {
        console.warn('Warning: rates request was cancelled by client code')
      } else if (error instanceof Error) {
        console.error(`Error ocurred while fetching rates: ${error.message}`)
      }
      return []
    }
  },
}
